import { CheckCircle2, XCircle, Clock, MinusCircle } from 'lucide-react'
import { Card, CardContent } from './ui/card'
import { Button } from './ui/button'
import { Link } from 'react-router-dom'

/*
  SubmissionStatusCard — gedeeld tussen KempenvisionPage en ImageCompoPage.
  Toont status van gebruiker's inzending (approved/rejected/pending/withdrawn).
  Props:
    submission     — object met status, title, en optioneel team_name/proposed_team_name/genre
    actionTo       — bijv. '/kempenvision/inleveren' of '/imagecompo/inleveren'
    actionLabel    — knop label (default 'Bekijk')
    titleFallback  — wat te tonen als submission.title leeg is
    subtitleFn     — functie die submission → subtitel string (voor module-specifieke details)
*/
export default function SubmissionStatusCard({
  submission,
  actionTo,
  actionLabel = 'Bekijk',
  titleFallback = '(geen titel)',
  subtitleFn = null,
}) {
  if (!submission) return null

  const status = submission.status
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending
  const Icon = config.icon
  const subtitle = subtitleFn
    ? subtitleFn(submission)
    : (submission.team_name ?? submission.proposed_team_name ?? '')

  return (
    <Card className={`${config.border} ${config.bg}`}>
      <CardContent className="p-4 flex items-center gap-4">
        <div className={`h-11 w-11 rounded-lg flex items-center justify-center shrink-0 ${config.iconBg}`}>
          <Icon className="h-6 w-6 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className={`text-xs uppercase tracking-widest font-semibold ${config.labelClass}`}>
            Jouw inzending — {config.label}
          </div>
          <div className="font-bold truncate">{submission.title || titleFallback}</div>
          {subtitle && (
            <div className="text-sm text-muted-foreground truncate">{subtitle}</div>
          )}
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to={actionTo}>{actionLabel}</Link>
        </Button>
      </CardContent>
    </Card>
  )
}

const STATUS_CONFIG = {
  approved: {
    icon: CheckCircle2,
    label: 'Goedgekeurd',
    border: 'border-emerald-500/40',
    bg: 'bg-emerald-500/5',
    iconBg: 'bg-emerald-500',
    labelClass: 'text-emerald-400',
  },
  rejected: {
    icon: XCircle,
    label: 'Afgekeurd',
    border: 'border-red-500/40',
    bg: 'bg-red-500/5',
    iconBg: 'bg-red-500',
    labelClass: 'text-red-400',
  },
  withdrawn: {
    icon: MinusCircle,
    label: 'Ingetrokken',
    border: 'border-slate-500/40',
    bg: 'bg-slate-500/5',
    iconBg: 'bg-slate-500',
    labelClass: 'text-slate-400',
  },
  pending: {
    icon: Clock,
    label: 'In behandeling',
    border: 'border-yellow-500/40',
    bg: 'bg-yellow-500/5',
    iconBg: 'bg-yellow-500',
    labelClass: 'text-yellow-400',
  },
}
